import { render } from "./ImageUploader.vue?vue&type=template&id=991beaa4&scoped=true"
import script from "./ImageUploader.vue?vue&type=script&lang=js"
export * from "./ImageUploader.vue?vue&type=script&lang=js"

import "./ImageUploader.vue?vue&type=style&index=0&id=991beaa4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-991beaa4"]])

export default __exports__